import common from "../common";

export default class AchievementPopup extends PIXI.Container
{
    constructor()
    {
        super();

        this.interactive = false;
        this.interactiveChildren = false;
        this.hitArea = new PIXI.Rectangle();

        this._unlockStack = [];

        this._width = 720;

        this._panel = new PIXI.Container();
        this._panel.x = P3.View.width * 0.5;
        this._panel.y = P3.View.height - 96;
        this._panel.visible = false;
        this.addChild(this._panel);

        this._panel.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("ui_achievements_title"), 50, 0, 50, 0);
        this._panel.image.width = this._width;
        this._panel.image.pivot.x = this._panel.image.width * 0.5;
        this._panel.addChild(this._panel.image);

        this._panel.icon = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._panel.icon.position.set(-this._width * 0.5 + 70, 56);
        this._panel.icon.anchor.set(0.5);
        this._panel.icon.scale.set(0.9);
        this._panel.addChild(this._panel.icon);

        this._panel.medal = new PIXI.Sprite(P3.assets.texture("ui_icon_medal"));
        this._panel.medal.position.set(0, this._panel.icon.y);
        this._panel.medal.anchor.set(0.5);
        this._panel.addChild(this._panel.medal);

        this._panel.tick = new PIXI.Sprite(P3.assets.texture("ui_achievement_tick_on"));
        this._panel.tick.position.set(this._width * 0.5 - 70, 56);
        this._panel.tick.anchor.set(0.5);
        this._panel.addChild(this._panel.tick);

        const style =
        {
            font: {name: "BBC Reith Sans", size: 22},
            tint: 0xFFFFFF,
            align: "center"
        };

        this._panel.nameText = new PIXI.extras.BitmapText("", style);
        this._panel.nameText.position.set(0, 56);
        this._panel.nameText.anchor.set(0.5);
        this._panel.addChild(this._panel.nameText);

        this._initPositionY = this._panel.y;

        common.achievements && common.achievements.signals.unlocked.add(this.onAchievementUnlocked, this);
        common.view && common.view.signals.resize.add(this.onViewResize, this);

        this.resize();
    }

    destroy()
    {
        common.achievements && common.achievements.signals.unlocked.detach(this.onAchievementUnlocked, this);
        common.view && common.view.signals.resize.detach(this.onViewResize, this);

        super.destroy({children: true});
    }

    resize()
    {
        this._panel.x = P3.View.width * 0.5;
    }

    animate()
    {
        this._panel.y = P3.View.height + this._panel.image.height;
        this._panel.image.width = this._width * 0.34;
        this._panel.image.pivot.x = this._panel.image.width * 0.5;

        this._panel.icon.visible = false;
        this._panel.medal.visible = true;
        this._panel.tick.visible = false;
        this._panel.nameText.visible = false;

        const a = new P3.utils.TWEEN.Tween(this._panel)
            .to({y: this._initPositionY}, 340)
            .delay(1000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.Out)
            .onStart(() =>
            {
                this._panel.visible = true;

                this._panel.medal.scale.set(0);
                new P3.utils.TWEEN.Tween(this._panel.medal.scale)
                    .to({x: 1, y: 1}, 200)
                    .easing(P3.utils.TWEEN.Easing.Back.Out)
                    .delay(300)
                    .start();
            });

        const b = new P3.utils.TWEEN.Tween(this._panel.image)
            .to({width: this._width}, 640)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onUpdate(() =>
            {
                this._panel.image.pivot.x = this._panel.image.width * 0.5;
            })
            .onComplete(() =>
            {
                new P3.utils.TWEEN.Tween(this._panel.medal)
                    .to({alpha: 0}, 100)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .onComplete(() =>
                    {
                        this._panel.medal.alpha = 1;
                        this._panel.medal.visible = false;
                    })
                    .start();

                this._panel.icon.alpha = 0;
                new P3.utils.TWEEN.Tween(this._panel.icon)
                    .to({alpha: 1}, 160)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .onStart(() =>
                    {
                        this._panel.icon.visible = true;
                    })
                    .start();

                this._panel.tick.alpha = 0;
                new P3.utils.TWEEN.Tween(this._panel.tick)
                    .to({alpha: 1}, 160)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .onStart(() =>
                    {
                        this._panel.tick.visible = true;
                    })
                    .start();

                this._panel.nameText.alpha = 0;
                new P3.utils.TWEEN.Tween(this._panel.nameText)
                    .to({alpha: 1}, 160)
                    .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                    .onStart(() =>
                    {
                        this._panel.nameText.visible = true;
                    })
                    .start();
            });

        const c = new P3.utils.TWEEN.Tween(this._panel)
            .to({y: P3.View.height + this._panel.image.height}, 300)
            .delay(2000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .onComplete(() =>
            {
                this.onAnimationFinished();
            });

        a.chain(b);
        b.chain(c);
        a.start();
    }

    setAchievement(achievement)
    {
        if (achievement)
        {
            this._panel.nameText.text = achievement.name;
            this._panel.icon.texture = achievement.icon;
        }
        else
        {
            this._panel.nameText.text = "";
            this._panel.icon.texture = PIXI.Texture.EMPTY;
        }
    }

    onAnimationFinished()
    {
        if (this._unlockStack.length > 0)
        {
            this._unlockStack.shift();
        }

        if (this._unlockStack.length > 0)
        {
            const next = this._unlockStack[0];
            this.setAchievement(next);
            this.animate();
        }
    }

    onAchievementUnlocked(achievement)
    {
        this._unlockStack.push(achievement);

        if (this._unlockStack.length <= 1)
        {
            this.setAchievement(achievement);
            this.animate();
        }
    }

    onViewResize(correct)
    {
        this.resize();
    }

    get currentAchievement()
    {
        return this._unlockStack.length > 0 ? this._unlockStack[0] : null;
    }
}